﻿import bxslider from './lib/bxslider';

export default class careers {
    constructor() {
        this.dom = {
            $: window.$,
            $window: $(window),
            $contentSlider: $('.content-bxslider'),
            $awardsSlider: $('.awards-bxslider'),
            $jobsearchBtn: $('.job-search-btn'),
            $togglebtn: $('.togglebtn')
        };

        if (this.dom.$awardsSlider.length || this.dom.$contentSlider.length) {
            this.init();
        }
        if (this.dom.$jobsearchBtn.length > 0) {
            this.jobSearch();
        }
        if (this.dom.$togglebtn.length > 0) {
            this.linkedInShowMore();
        }
    }

    init() {

        let boxCountToDisplay = parseInt(fetchParam($('#boxCountToDisplay'), '5'));
        let disableAnimation = (fetchParam($('#disableAnimation'), 'true') == 'true')
        let animationInterval = parseInt(fetchParam($('#animationInterval'), '3000'));
        let showDots = (fetchParam($('#showDots'), 'true') == 'true');
        let tileWidth = parseInt(fetchParam($('#tileWidth'), '220'));
        let tileMargin = parseInt(fetchParam($('#tileMargin'), '25'));

        function fetchParam($param, defVal) {
            return ($param.length > 0 && $param.val().length > 0) ? $param.val() : defVal;
        }
        if (window.innerWidth < 992) {
            this.dom.$contentSlider.bxSlider({
                mode: 'horizontal',
                slideWidth: tileWidth,
                minSlides: 1,
                maxSlides: 2,
                moveSlides: 1,
                slideMargin: tileMargin,
                pause: animationInterval,
                speed: (disableAnimation ? 0 : 1000),
                pager: showDots,
                auto: true,
                hideControlOnEnd: true,
                controls: false,
                touchEnabled: false
            });
        }

        this.dom.$awardsSlider.bxSlider({
            mode: 'horizontal',
            slideWidth: tileWidth,
            minSlides: 1,
            maxSlides: boxCountToDisplay,
            moveSlides: 1,
            slideMargin: tileMargin,
            pause: animationInterval,
            speed: (disableAnimation ? 0 : 1000),
            pager: showDots,
            auto: true,
            hideControlOnEnd: true,
            nextText: '&rsaquo;',
            prevText: '&lsaquo;',
            controls: false,
            touchEnabled: false
        });
    }

    jobSearch() {
        //Setup search function
        this.dom.$jobsearchBtn.on('click', function () {
            document.getElementById("searchFrom").submit();
        })
    }

    linkedInShowMore() {
        this.dom.$togglebtn.click(function () {
            var button = $(this);
            var textId = $(this).data('target');
            var textContent = $(textId);

            if (textContent.hasClass('collapsed')) {
                textContent.removeClass('collapsed').addClass('expanded');
                button.text('Mniej');
            } else {
                textContent[0].scrollTop = 0;
                textContent.removeClass('expanded').addClass('collapsed');
                button.text('Więcej');
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', () => new careers());